import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { Component } from 'react'
import Grid from 'shared/components/gif-grid/grid'
import preloadRange from 'shared/components/gif-grid/preload-range'
import gradient from 'shared/components/gif-grid/gradient-grid'
import scrollPosition, * as scrolling from 'shared/components/gif-grid/scroll-position-props-proxy'
import channelProps from 'shared/prop-types/channel'
import css, { gridItemHeight, gridItemWidth } from './branch-grid.css'

const { arrayOf, bool } = PropTypes

const preload = {
        low: -innerWidth * 3,
        high: innerWidth * 3,
    },
    priority = {
        low: -200,
        high: innerWidth + 200,
    }

@scrollPosition(window, scrolling.VERTICAL, scrolling.SCROLL_STOP, 0)
@gradient()
@preloadRange(preload, priority)
class BranchGrid extends Grid {
    getGifWidth() {
        return parseInt(gridItemWidth, 10)
    }
    getGifHeight() {
        return parseInt(gridItemHeight, 10)
    }
}

/**
 * Channel - Branch Pages: Controls the branch channel pages.
 * This view handles animating visible gifs in the branch grid,
 * and changing grid gradient color while scrolling.
 *
 * @class ChannelBranch
 * @param {Object} options
 */
export default class ChannelBranch extends Component {
    static propTypes = {
        channelChildren: arrayOf(channelProps),
        autoPlay: bool,
    }
    render() {
        const { channelChildren, autoPlay } = this.props
        const processedGifs = channelChildren.map(g => {
            const gif = { ...g }
            gif.id = gif.slug
            gif.label = gif.display_name
            if (gif.featured_gif && gif.featured_gif.images) {
                const { images, is_sticker } = gif.featured_gif
                gif.images = {
                    animated: images.fixed_height,
                    still: images.fixed_height_still,
                }
                gif.is_sticker = is_sticker
            } else {
                gif.images = { animated: '', still: '' }
            }
            return gif
        })
        return (
            <BranchGrid
                gridTemplate={'channel'}
                shouldUseLinkFallback={true}
                gifs={processedGifs}
                css={css}
                autoPlay={autoPlay}
                isOffScreen={false}
            />
        )
    }
}
